import { render, staticRenderFns } from "./AppPersonalMenu.vue?vue&type=template&id=68ea3f8c&scoped=true&"
import script from "./AppPersonalMenu.vue?vue&type=script&lang=js&"
export * from "./AppPersonalMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppPersonalMenu.vue?vue&type=style&index=0&id=68ea3f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea3f8c",
  null
  
)

export default component.exports